import STATE from '../constants/state';
import {breakpoints} from '../constants/breakpoints';
import showScrollProgress from '../utils/showScrollProgress';

const selectors = {
  card: '.js-info-card',
};

const handleInfoCardAnimation = () => {
  const cards = document.querySelectorAll(selectors.card);
  if (!cards.length) return;

  const rootBottom = 0.5; // it is responsible for progress margin value
  const multiplier = 1 / rootBottom;
  const baseScaleValue = breakpoints.tablet > window.innerWidth ? 0.9 : 0.8;

  let scaleValue = baseScaleValue;

  cards.forEach((card) => {
    card.style.setProperty('--scale', scaleValue);

    showScrollProgress(card, ({progress}) => {
      if (progress > rootBottom) return;

      scaleValue = baseScaleValue + (1 - baseScaleValue) * progress * multiplier;
      card.classList.add(STATE.active);
      card.style.setProperty('--scale', scaleValue);
    });
  });
};

export default handleInfoCardAnimation;
